import { AiFillAppstore } from "react-icons/ai";
import { FaMobile, FaGlobe} from "react-icons/fa";
import { SiProgress, SiAntdesign } from "react-icons/si";
import { IoIosCloud } from 'react-icons/io';

// Features Data
export const featuresData = [
  {
    id: 2,
    icon: <AiFillAppstore />,
    title: "Web Development",
    des: "Web development encompasses the creation and maintenance of websites and applications.",
  },
  {
    id: 5,
    icon: <SiAntdesign />,
    title: "UX Design",
    des: "UI (User Interface) and UX (User Experience) design focus on creating intuitive, visually appealing digital experiences.",
  },
  {
    id: 6,
    icon: <IoIosCloud />,
    title: "Cloud Computing",
    des: "Cloud computing enables on-demand access to computing resources, scalability,flexibility & efficiency for diverse applications and businesse",
  },
];
